import React from 'react';
import { useTranslation } from 'react-i18next';

import { useResponsive } from '../../hooks/useResponsive';

import { PolicyStatusPill } from './common';

import styles from './PolicyTopInformation.module.css';

const PolicyDetailsHeader = ({ title, description }) => {
  const { isMobile } = useResponsive();

  return (
    <div className={styles.policyDetailsHeaderField}>
      <h4 aria-hidden={isMobile}>{title}</h4>

      <h6 aria-hidden={!isMobile}>{title}</h6>

      <span>{description}</span>
    </div>
  );
};

const PolicyTopInformation = ({ policyData = {} }) => {
  const { t } = useTranslation('petDemos');

  return (
    <>
      <div className={styles.policyTitleContainer}>
        <h2 className={styles.policyTitle}>
          {t('policyInformation.yourPolicy')}
        </h2>

        <PolicyStatusPill status={policyData.PolicyStatus} />
      </div>

      <div className={styles.policyDetailsContainer}>
        <PolicyDetailsHeader
          description={policyData.certificateNumber}
          title={t('policyInformation.certificateNumber')}
        />

        <PolicyDetailsHeader
          description={t('policyInformation.coveragePeriodTotal', {
            count: Array.isArray(policyData.NeedsPetDemographics)
              ? policyData.NeedsPetDemographics.length
              : 0,
          })}
          title={t('policyInformation.policyPeriods')}
        />

        <PolicyDetailsHeader
          description={policyData.CompanyName}
          title={t('policyInformation.company')}
        />
      </div>
    </>
  );
};

export { PolicyTopInformation };
